import styled from 'styled-components'
import { Color } from '../config/styles/colors'

export const SplashScreen = styled.div`
   position: relative;

   background-color: ${Color.PRIMARY};

   display: flex;
   flex-direction: column;

   .flex-item-1 {
      flex: 1.8;
      display: flex;
      justify-content:center;
      align-items: center;
      z-index: 1;
   }

   .flex-item-2 {
       flex: 1;
       z-index: 1;

       #launch-container {
        display: block;
        margin: auto;
        width: 28%;
       }
    }
   

   height: 100%;
   width: 100%:
`

export const PlayButton = styled.img`
  display: block;
  width: 100%;
`

export const CrayolaLogo = styled.img`
  width: 75%;
`

export const Chevron = styled.img<{ right?: boolean }>`
  position: absolute;
  display: block;

  width: 40%;
  height: auto;

  bottom: 0;

  ${({ right }) => (right ? 'right: 0' : '  left: 0')};
`
